/**
 * tokenRefresh.ts — 응답의 X-New-Token(늘려 준 토큰)을 받아 둘 때 «같은 사람» 토큰일 때만 바꿔 끼운다 (2026-10-27)
 *  지도사 「(오재인 화면에서) 돌아가기 눌러도 안 돌아감」 — 전환해 쓰는 토큰은 짧아(12시간) 응답마다 새 토큰이 왔고,
 *  「임우승으로 돌아가기」로 임우승 토큰을 넣은 뒤에 늦게 도착한 응답이 오재인 토큰으로 다시 덮어썼다.
 *  토큰 안의 계정(id) · 전환 표시(acting_by)가 지금 들고 있는 토큰과 같을 때만 바꾼다(다른 계정 토큰은 버림).
 *  + 지금 토큰보다 더 늦게 끝나는(새) 토큰만 · 이미 끝난 토큰은 버림(2026-10-28 캐시된 옛 응답의 옛 토큰)
 */
function claims(tok: string | null): { who: string; exp: number } | null {
  if (!tok) return null;
  try {
    const p = tok.split('.')[1] || '';
    const json = JSON.parse(decodeURIComponent(escape(atob(p.replace(/-/g, '+').replace(/_/g, '/'))))) as { id?: string; acting_by?: string; exp?: number };
    return { who: `${json.id || ''}|${json.acting_by || ''}`, exp: Number(json.exp) || 0 };
  } catch (e) { return null; }
}
/** 새 토큰 받아 두기 — 지금 토큰과 같은 계정 · 같은 전환 상태일 때만 · 바꿨으면 true */
export function keepNewToken(nt: string | null | undefined, key = 'token'): boolean {
  if (!nt) return false;
  try {
    const cur = localStorage.getItem(key);
    const c = claims(cur), n = claims(nt);
    if (cur && (!c || !n || c.who !== n.who)) return false;
    // 2026-10-28 「오재인으로 전환 후 업무관리 누르면 임우승으로」 — 브라우저가 어제 응답(디스크 캐시 · 상태 200)을 꺼내 주면서
    //   그 안의 옛 X-New-Token(어제 오재인 전환 토큰 · 이미 끝남)이 같은 계정이라 통과해 방금 받은 토큰을 덮었다 → 더 늦게 끝나는 토큰만 받는다
    if (n && n.exp && n.exp * 1000 <= Date.now()) return false;
    if (c && n && c.exp && n.exp <= c.exp) return false;
    localStorage.setItem(key, nt);
    return true;
  } catch (e) { return false; }
}
